module.exports = __webpack_public_path__ + "statics/img/Marketing-3.7219534e.png";